import script from "./ShareholderChangeView.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareholderChangeView.vue?vue&type=script&setup=true&lang=js"

import "./ShareholderChangeView.vue?vue&type=style&index=0&id=164275ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-164275ce"]])

export default __exports__